export default __webpack_public_path__ + "static/media/mcgill-landscape.ef9945a3.jpeg";